import {
  Box,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { NegotiationRoundV2InviteDto } from "../../../../autogen/bff-api";

interface Props {
  invites: NegotiationRoundV2InviteDto[];
}

export const RoundInvitesList = ({ invites }: Props) => {
  const { t } = useTranslation();

  return (
    <Box border="1px solid" borderColor="smBorder" rounded="md" overflow="hidden">
      <TableContainer>
        <Table variant="simple" size="sm">
        <Thead>
          <Tr>
            <Th>{t("Organization")}</Th>
            <Th>{t("Contact persons")}</Th>
            <Th>{t("Message")}</Th>
          </Tr>
        </Thead>
        <Tbody>
          {invites.length === 0 && (
            <Tr>
              <Td colSpan={3} textAlign="center" color="smMuted">
                {t("No organizations invited to this round.")}
              </Td>
            </Tr>
          )}
          {invites.map((invite) => (
            <Tr key={invite.organizationId}>
              <Td>
                <Text fontSize="sm" fontWeight="medium">
                  {invite.organizationName}
                </Text>
              </Td>
              <Td>
                <Text fontSize="sm" color="smMuted">
                  {invite.persons.length > 0
                    ? invite.persons.map((p) => p.name).join(", ")
                    : "–"}
                </Text>
              </Td>
              <Td whiteSpace="normal">
                <Text fontSize="sm" color={invite.message ? "smText" : "smMuted"} whiteSpace="pre-wrap">
                  {invite.message || "–"}
                </Text>
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
      </TableContainer>
    </Box>
  );
};
